import React from 'react'
import { Link } from 'react-router-dom'
import { pricingOne } from '../data/sooftware'

import {FiChevronRight} from '../assets/icons/vander'

export default function PricingOne() {
  return (
    <div className="row">
        {pricingOne.map((item,index)=>{
            let Icon = item.icon
            return(
                <div className="col-md-4 col-12 mt-4 pt-2" key={index}>
                    <div className="card pricing-plan border-0 shadow rounded">
                        <div className="plans p-4 border-bottom">
                            <i className={item.iconClass}><Icon/></i>
                            <h4 className="title">{item.title}</h4>
                            <ul className="list-unstyled mt-3 mb-0 ps-0">
                                {item.feature.map((el,index)=>{
                                    return(
                                        <li className="feature-list text-muted mb-1" key={index}>{el}</li>
                                    )
                                })}
                            </ul>
                        </div>
                        <div className="rates p-3 px-4">
                            <Link to="#" className="text-dark">
                                <h5 className="float-end icon mt-3"><i className="h3 mb-0 me-2"><FiChevronRight/></i></h5>
                                <div className="d-flex">
                                    <span className="h5 mb-0 mt-2">$</span>
                                    <span className="price h1 mb-0">{item.value}</span>
                                    <span className="h5 align-self-end mb-0">/mo</span>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            )
        })}
    </div>
  )
}
